import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterZCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLetterZCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8.90625 7.77246V9.04395H13.2305V9.14941L8.7832 15.2197V16.2275H15.2109V14.9561H10.6699V14.8506L15.0996 8.78027V7.77246H8.90625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterZCircle;
